/*

👋 “Hey” from the Praxis team!

'apiConfig' is one pattern that can be used to set environment-based values at
build time. This happens by creating an environment variable REACT_APP_ENV,
and then matching corresponding keys to each environment in the 'envConfigs'
object below. To learn more about how to set REACT_APP_ENV, view the README
generated with this app.


For an alternative pattern - using TAP configuration to set environment-based
values at cluster initialization - see: @praxis/component-runtime-env -
https://praxis.prod.target.com/components/runtime-env
*/
import merge from 'lodash/merge'

// configurations shared between most or all environments can be stored in
// commonConfig
const commonConfig = {
  apiKey: '740e9db6ad31473744ab35362a9fc53a8e1a96c4',
  OTELApiKey: 'd799e230b3ec180ffb0b18ae5a88e87d6ec2aadd',
  accessControlGroups: ['APP-LPP-VENDORS'],
}

const envConfigs = {
  local: {
    auth: {
      authorizationUrl:
        'https://oauth.iam.perf.partnersonline.com/auth/oauth/v2/tgt/authorize/nla/1',
      logoutUrl:
        'https://oauth.iam.perf.partnersonline.com/login/responses/logoff.html',
      clientId: 'hesperides_external_npe_im',
    },
    analytics: {
      appName: 'ITEM_COST_MANAGEMENT_EXTERNAL',
      url: 'https://stage-api.target.com/firefly_internal_events/v1/external',
    },
    logging: {
      url: 'localhost:3000/log_message',
    },
    hesperidesexternal: {
      url: 'https://prometheushesp-dev.dev.target.com',
    },
  },
  dev: {
    auth: {
      // create a non-prod ID2.0 OAuth Client ID unique to your app needs at
      // http://go/oauth
      // this clientID will not work in deployed environments
      authorizationUrl:
        'https://oauth.iam.perf.partnersonline.com/auth/oauth/v2/tgt/authorize/nla/1',
      logoutUrl:
        'https://oauth.iam.perf.partnersonline.com/login/responses/logoff.html',
      clientId: 'hesperides_external_npe_im',
    },
    analytics: {
      appName: 'ITEM_COST_MANAGEMENT_EXTERNAL',
      url: 'https://stage-api.target.com/firefly_internal_events/v1/external',
    },
    logging: {
      url: 'https://hesperidesexternal-dev.dev.target.com/log_message',
    },
    hesperidesexternal: {
      url: 'https://hesperidesexternal-dev.dev.target.com',
    },
  },
  stg: {
    auth: {
      authorizationUrl:
        'https://oauth.iam.perf.partnersonline.com/auth/oauth/v2/tgt/authorize/nla/1',
      logoutUrl:
        'https://oauth.iam.perf.partnersonline.com/login/responses/logoff.html',
      clientId: 'hesperides_external_npe_im',
    },
    analytics: {
      appName: 'ITEM_COST_MANAGEMENT_EXTERNAL',
      url: 'https://stage-api.target.com/firefly_internal_events/v1/external',
    },
    logging: {
      url: 'https://costmanagement.perf.partnersonline.com/log_message',
    },
    hesperidesexternal: {
      url: 'https://costmanagement.perf.partnersonline.com',
    },
  },
  prod: {
    auth: {
      authorizationUrl:
        'https://oauth.iam.partnersonline.com/auth/oauth/v2/tgt/authorize/nla/1',
      logoutUrl:
        'https://oauth.iam.partnersonline.com/login/responses/logoff.html',
      // clone your non-prod ID2.0 OAuth Client ID to a production Client ID
      // at http://go/oauth',
      // this clientID will not work in deployed environments
      clientId: 'hesperides_external_prod_im',
    },
    analytics: {
      appName: 'ITEM_COST_MANAGEMENT_EXTERNAL',
      url: 'https://api.target.com/firefly_internal_events/v1/external',
    },
    logging: {
      url: 'https://costmanagement.partnersonline.com/log_message',
    },
    hesperidesexternal: {
      url: 'https://costmanagement.partnersonline.com',
    },
    apiKey: 'de72774438f2669cdf06d65267a6cda202c2a275',
  },
}

const appEnv = process.env.REACT_APP_ENV
const config = envConfigs[appEnv]

// commonConfig and the config for the matching REACT_APP_ENV are combined.
// Values in the environment-specific config will overwrite commonConfig keys
// if they share the same name.
const apiConfig = merge(commonConfig, config)

export default apiConfig
